export default "__VITE_ASSET__CTg79CFU__"